import { useTrackPageViews } from './useTrackPageViews';
import { useTrackExternalLinkClick } from './useTrackExternalLinkClick';

export function useNavigationTracking() {
	useTrackPageViews();
	useTrackExternalLinkClick();
}
